import React, { useRef } from "react"
import { Form } from "react-final-form"
import { get } from "lodash"
//omit
import arrayMutators from "final-form-arrays"
import {
  useTranslate,
  sanitizeEmptyValues,
  getFormInitialValues,
  useNotify,
  useDataProvider,
} from "react-admin"
import SimpleFormView from "./SimpleFormView"
import CustomFormView from "./CustomFormView"

const SimplePOInventoryForm = ({
  initialValues,
  defaultValue,
  saving,
  typePostUrl,
  ...props
}) => {
  const notify = useNotify()
  let redirect = useRef(props.redirect)
  // We don't use state here for two reasons:
  // 1. There no way to execute code only after the state has been updated
  // 2. We don't want the form to rerender when redirect is changed
  const setRedirect = (newRedirect) => {
    redirect.current = newRedirect
  }

  const translate = useTranslate()
  const dataProvider = useDataProvider()
  const finalInitialValues = getFormInitialValues(
    initialValues,
    defaultValue,
    props.record
  )

  const submit = (values) => {
    // const finalRedirect =
    //   typeof redirect.current === undefined ? props.redirect : redirect.current
    const finalValues = sanitizeEmptyValues(finalInitialValues, values)
    // console.log(finalValues)
    // console.log(finalRedirect)
    // props.save(finalValues, finalRedirect)
    if (get(finalValues, "items[0].result.product_id", undefined)) {
      const orderItems = finalValues.items.map((item, index) => {
        return {
          qty: item.qty,
          product_id: item.product_id,
          promotions: item.promotions,
        }
      })
      if (typePostUrl && typePostUrl === "CREATE") {
        let params = {
          delivery_date: get(finalValues, "delivery_date", ""),
          status: finalValues.status,
          remarks: get(finalValues, "remarks", ""),
          items: orderItems,
        }
        if (finalValues.dealer_id) {
          params["dealer_id"] = finalValues.dealer_id
        }
        // console.log(params)
        dataProvider
          .create("purchaseOrder", {
            data: params,
          })
          .then((response) => {
            if (response && response.data) {
              // console.log(response.data)
              notify("resources.po.messages.element_created")
              props.history.push("/inventories")
            } else {
              notify("resources.po.messages.create_order", "warning")
            }
          })
      } else if (typePostUrl && typePostUrl === "UPDATE") {
        // const myItems = get(finalValues, "items", [])
        // const newDetails = myItems.map((item) => {
        //   return {
        //     ...item.result,
        //   }
        // })
        // let params = omit(finalValues, ["items"])
        // params["details"] = newDetails
        // dataProvider
        //   .update("purchaseOrder", {
        //     id: finalValues.id,
        //     data: params,
        //     previousData: finalValues,
        //   })
        //   .then((response) => {
        //     if (response && response.data) {
        //       notify("resources.po.messages.element_updated")
        //       props.history.push("/purchaseOrder")
        //     } else {
        //       notify("resources.po.messages.create_order", "warning")
        //     }
        //   })
      }
    } else {
      notify("resources.po.messages.orderItemsEmpty", "warning")
    }
  }
  const { isCustomRender, ...newProps } = props
  return (
    <Form
      key={props.version}
      initialValues={finalInitialValues}
      onSubmit={submit}
      mutators={{
        ...arrayMutators,
        updateField: ([field, value], state, utils) => {
          utils.changeValue(state, field, () => value)
        },
      }}
      keepDirtyOnReinitialize
      destroyOnUnregister
      subscription={defaultSubscription}
      {...newProps}
      render={({
        form: {
          mutators: { updateField },
        },
        ...formProps
      }) =>
        isCustomRender ? (
          <CustomFormView
            saving={formProps.submitting || saving}
            translate={translate}
            setRedirect={setRedirect}
            {...newProps}
            {...formProps}
            updateField={(key, value) => updateField(key, value)}
          />
        ) : (
          <SimpleFormView
            saving={formProps.submitting || saving}
            translate={translate}
            setRedirect={setRedirect}
            {...newProps}
            {...formProps}
          />
        )
      }
    />
  )
}

const defaultSubscription = {
  submitting: true,
  pristine: true,
  valid: true,
  invalid: true,
}

export default SimplePOInventoryForm
